import axios from "@/plugins/axios";
import categories from "./categories";

let url = "/api/v1/programs";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    categories,
};
